import React from "react"
import categoryStore from "stores/categoryStore"
import {Table} from "semantic-ui-react"
import languageStore from "stores/languageStore"


const CustomFields = ( { product, columns } ) => {
	let primaryCategory = product.category
	let cid = primaryCategory && primaryCategory.cat_id || String( product.category && product.category.map_id )
	const [translations, setTranslations] = React.useState( false )
	React.useEffect( () => {
		if ( !columns ) {
			return setTranslations( true )
		}
		let promises = columns
			.filter( e => e )
			.map( columnKey => {
				categoryStore.loadTranslatedFields( { locale: languageStore.locale, fieldName: columnKey } )
			} )

		let translations = Promise.all( promises )
			.then( res => {
				setTranslations( true )
			} )

	}, [product, columns] )

	if ( !translations ) return <div>
		LOADING
	</div>
	return (
		<div>
			<Table basic={"very"}>
				<Table.Body>

					{/*<Table.Row positive >*/}
					{/*	<Table.Cell>product.desc.des</Table.Cell>*/}
					{/*	<Table.Cell><b>{product.desc.des}</b></Table.Cell>*/}
					{/*</Table.Row>*/}

					{/*<Table.Row positive>*/}
					{/*	<Table.Cell>product.desc.short_des</Table.Cell>*/}
					{/*	<Table.Cell><b>{product.desc.short_des}</b></Table.Cell>*/}
					{/*</Table.Row>*/}

					<Table.Row>
						<Table.Cell>Artikel-Nr.</Table.Cell>
						<Table.Cell><b>{product.map_id}</b></Table.Cell>
					</Table.Row>
					<Table.Row>
						<Table.Cell>Beschreibung</Table.Cell>
						<Table.Cell><b>{product.desc.short_des}</b></Table.Cell>
					</Table.Row>

					{/*<Table.Row>*/}
					{/*	<Table.Cell>VE</Table.Cell>*/}
					{/*	<Table.Cell><b><span>{product.unit_multi} Stück</span></b></Table.Cell>*/}
					{/*</Table.Row>*/}

					{product.extraValue.Z_Verpackungseinheit_Anzahl && <Table.Row>
						<Table.Cell>VE </Table.Cell>
						<Table.Cell><b><span>{product.extraValue.Z_Verpackungseinheit_Anzahl} </span></b></Table.Cell>
					</Table.Row>}


					{/*<Table.Row>*/}
					{/*	<Table.Cell>Verfügbar</Table.Cell>*/}
					{/*	<Table.Cell><b><span>{product.stock} Stück</span></b></Table.Cell>*/}
					{/*</Table.Row>*/}

					{columns && columns
						.filter( e => e )
						.filter( e => e !== "Z_Verpackungseinheit_Anzahl" )
						.map( columnKey => {
							if ( !product.extraValue[ columnKey ] ) return null
							return <React.Fragment key={columnKey}>
								<Table.Row>
									<Table.Cell>{translate( columnKey )}</Table.Cell>
									<Table.Cell><b>{product.extraValue[ columnKey ] || "Kein Wert"}</b></Table.Cell>
								</Table.Row>
							</React.Fragment>
						} )}
				</Table.Body>
			</Table>
		</div>
	)
}


export default CustomFields


// WEBPACK FOOTER //
// ./src/components/CustomFields/CustomFields.js